type BrandImages = {
  appliancePlateImage: string | null;
  brands: string[];
  modelImages: {
    applianceSuperCategory: string;
    defaultImage: string;
    mappings: {
      applianceCode: string;
      image: string;
    }[];
  }[];
};
export const brandImages: Record<string, BrandImages> = {
  CANDY: {
    appliancePlateImage: 'img_appliance-info-plates_candy.png',
    brands: ['HOOVER', 'BAUMATIC', 'ROSIERES', 'IBERNA', 'KELVINATOR', 'HAIER'],
    modelImages: [
      {
        applianceSuperCategory: 'COOKER',
        defaultImage: 'img_candy_oven.png',
        mappings: [
          {
            applianceCode: '1C',
            image: 'img_candy_oven.png',
          },
          {
            applianceCode: 'HB',
            image: 'img_candy_hob.png',
          },
          {
            applianceCode: 'CH',
            image: 'img_candy_hood.png',
          },
          {
            applianceCode: 'CK',
            image: 'img_candy_cookers-with-oven.png',
          },
          {
            applianceCode: 'OV',
            image: 'img_candy_oven.png',
          },
        ],
      },
      {
        applianceSuperCategory: 'MICROWAVE',
        defaultImage: 'img_candy_microwave-oven.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'DISHWASHER',
        defaultImage: 'img_candy_dishwasher.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'FRIDGE FREEZER',
        defaultImage: 'img_candy_refrigerator.png',
        mappings: [
          {
            applianceCode: 'FZ',
            image: 'img_candy_freezer.png',
          },
          {
            applianceCode: '1E',
            image: 'img_candy_freezer.png',
          },
          {
            applianceCode: 'RU',
            image: 'img_candy_refrigerator.png',
          },
          {
            applianceCode: '1O',
            image: 'img_candy_refrigerator.png',
          },
        ],
      },
      {
        applianceSuperCategory: 'DRYER',
        defaultImage: 'img_candy_tumble-dryer.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHER DRYER',
        defaultImage: 'img_candy_washer-dryer.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHING MACHINE',
        defaultImage: 'img_candy_front-loading-machine.png',
        mappings: [],
      },
    ],
  },
  BAUMATIC: {
    appliancePlateImage: 'img_appliance-info-plates_baumatic.png',
    brands: [],
    modelImages: [
      {
        applianceSuperCategory: 'COOKER',
        defaultImage: 'img_baumatic_single-oven.png',
        mappings: [
          {
            applianceCode: 'RQ',
            image: 'img_baumatic_range-cooker.png',
          },
          {
            applianceCode: 'HB',
            image: 'img_baumatic_hob.png',
          },
          {
            applianceCode: 'CH',
            image: 'img_candy_hood.png',
          },
          {
            applianceCode: 'CK',
            image: 'img_baumatic_slow-in-cooker.png',
          },
          {
            applianceCode: 'OV',
            image: 'img_baumatic_single-oven.png',
          },
        ],
      },
      {
        applianceSuperCategory: 'MICROWAVE',
        defaultImage: 'img_baumatic_microwave.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'DISHWASHER',
        defaultImage: 'img_baumatic_dishwasher.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'FRIDGE FREEZER',
        defaultImage: 'img_baumatic_fridge-freezer.png',
        mappings: [
          {
            applianceCode: 'FZ',
            image: 'img_baumatic_freezer.png',
          },
          {
            applianceCode: '1E',
            image: 'img_baumatic_freezer.png',
          },
          {
            applianceCode: 'RU',
            image: 'img_baumatic_fridge.png',
          },
          {
            applianceCode: '1O',
            image: 'img_baumatic_fridge.png',
          },
          {
            applianceCode: 'FF',
            image: 'img_baumatic_fridge-freezer.png',
          },
          {
            applianceCode: 'CN',
            image: 'img_baumatic_fridge-freezer.png',
          },
        ],
      },
      {
        applianceSuperCategory: 'DRYER',
        defaultImage: 'img_baumatic_tumble-dryer.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHER DRYER',
        defaultImage: 'img_baumatic_washer-dryer.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHING MACHINE',
        defaultImage: 'img_baumatic_washing-machine.png',
        mappings: [],
      },
    ],
  },
  HOOVER: {
    appliancePlateImage: 'img_appliance-info-plates_hoover.png',
    brands: [],
    modelImages: [
      {
        applianceSuperCategory: 'COOKER',
        defaultImage: 'img_hoover_hob.png',
        mappings: [
          {
            applianceCode: 'HB',
            image: 'img_hoover_hob.png',
          },
          {
            applianceCode: 'CH',
            image: 'img_hoover_hood.png',
          },
        ],
      },
      {
        applianceSuperCategory: 'MICROWAVE',
        defaultImage: 'img_hoover_microwave.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'DISHWASHER',
        defaultImage: 'img_hoover_dishwasher.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'VACUUM CLEANER',
        defaultImage: 'img_hoover_vacuums.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHER DRYER',
        defaultImage: 'img_hoover_washer-dryer.png',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHING MACHINE',
        defaultImage: 'img_hoover_washing-machine.png',
        mappings: [],
      },
    ],
  },
  WHIRLPOOL: {
    appliancePlateImage: null,
    modelImages: [
      {
        applianceSuperCategory: 'COOKER',
        defaultImage: 'img_whirlpool_cooker_oven.jpg',
        mappings: [
          {
            applianceCode: '1C',
            image: 'img_whirlpool_cooker_oven.jpg',
          },
          {
            applianceCode: 'RQ',
            image: 'img_whirlpool_cooker_oven.jpg',
          },
          {
            applianceCode: 'CH',
            image: 'img_whirlpool_hood.jpg',
          },
        ],
      },
      {
        applianceSuperCategory: 'MICROWAVE',
        defaultImage: 'img_whirlpool_microwave.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'DISHWASHER',
        defaultImage: 'img_whirlpool_dishwasher.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'FRIDGE FREEZER',
        defaultImage: 'img_whirlpool_fridge_freezer.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'DRYER',
        defaultImage: 'img_whirlpool_tumble-dryer.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHING MACHINE',
        defaultImage: 'img_whirlpool_front-loading-machine.jpg',
        mappings: [],
      },
    ],
    brands: [
      'ARISTON',
      'BAUKNECHT',
      'CANNON',
      'CREDA',
      'HOTPOINT',
      'IGNIS',
      'IKEA',
      'INDESIT',
      'KITCHENAID',
      'MAYTAG',
      'PROLINE',
      'SCHOLTES',
      'SWAN',
    ],
  },
  ELECTROLUX: {
    appliancePlateImage: 'img_appliance-info-plates_electrolux.jpg',
    modelImages: [
      {
        applianceSuperCategory: 'DISHWASHER',
        defaultImage: 'img_electrolux_dishwasher.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'VACUUM CLEANER',
        defaultImage: 'img_electrolux_vacuum-cleaners.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'COOKER',
        defaultImage: 'img_electrolux_cooker.jpg',
        mappings: [
          {
            applianceCode: '1C',
            image: 'img_electrolux_oven.jpg',
          },
          {
            applianceCode: 'CK',
            image: 'img_electrolux_cooker.jpg',
          },
          {
            applianceCode: 'HB',
            image: 'img_electrolux_hob.jpg',
          },
          {
            applianceCode: 'CH',
            image: 'img_electrolux_hood.jpg',
          },
          {
            applianceCode: 'OV',
            image: 'img_electrolux_oven.jpg',
          },
        ],
      },
      {
        applianceSuperCategory: 'MICROWAVE',
        defaultImage: 'img_electrolux_microwave.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'FRIDGE FREEZER',
        defaultImage: 'img_electrolux_fridge-freezer.jpg',
        mappings: [
          {
            applianceCode: 'FR',
            image: 'img_electrolux_fridge.jpg',
          },
        ],
      },
      {
        applianceSuperCategory: 'DRYER',
        defaultImage: 'img_electrolux_tumble-dryer.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHING MACHINE',
        defaultImage: 'img_electrolux_washing-machine.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'VACUUM CLEANER',
        defaultImage: 'img_electrolux_vacuum-cleaners.jpg',
        mappings: [],
      },
    ],
    brands: [
      'AEG',
      'ARTHUR MARTIN',
      'BENDIX',
      'DE DIETRICH',
      'ELECTRA',
      'ELECTROLUX',
      'ELEKTRA',
      'FAURE',
      'FIRENZI',
      'FRIGIDAIRE',
      'ICELINE',
      'JOHN LEWIS',
      'JUNO',
      'LAMONA',
      'MOFFAT',
      'NEUE',
      'PARKINSON COWAN',
      'PRIMA',
      'PRIVILEG',
      'PROGRESS',
      'REX',
      'TRICITY BENDIX',
      'ZANKER',
      'ZANUSSI',
      'ZOPPAS',
    ],
  },
  BEKO: {
    appliancePlateImage: null,
    modelImages: [
      {
        applianceSuperCategory: 'DISHWASHER',
        defaultImage: 'img_beko_dishwasher.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'VACUUM CLEANER',
        defaultImage: 'img_beko_vacuums.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'COOKER',
        defaultImage: 'img_beko_cooker.jpg',
        mappings: [
          {
            applianceCode: '1C',
            image: 'img_beko_oven.jpg',
          },
          {
            applianceCode: 'CH',
            image: 'img_beko_hood.jpg',
          },
          {
            applianceCode: 'HB',
            image: 'img_beko_hob.jpg',
          },
          {
            applianceCode: 'OV',
            image: 'img_beko_oven-compact.jpg',
          },
          {
            applianceCode: 'RQ',
            image: 'img_beko_range-cooker.jpg',
          },
        ],
      },
      {
        applianceSuperCategory: 'FRIDGE FREEZER',
        defaultImage: 'img_beko_freezer.jpg',
        mappings: [
          {
            applianceCode: 'CN',
            image: 'img_beko_american-style-fridge-freezer.jpg',
          },
          {
            applianceCode: 'FF',
            image: 'img_beko_fridge-freezer.jpg',
          },
          {
            applianceCode: 'FR',
            image: 'img_beko_fridge.jpg',
          },
        ],
      },
      {
        applianceSuperCategory: 'DRYER',
        defaultImage: 'img_beko_tumble-dryer.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'COFFEE MACHINE',
        defaultImage: 'img_beko_coffee-machine.jpg',
        mappings: [],
      },
      {
        applianceSuperCategory: 'WASHING MACHINE',
        defaultImage: 'img_beko_washing-machine.jpg',
        mappings: [],
      },
    ],
    brands: ['BEKO', 'BLOMBERG', 'FLAVEL', 'GRUNDIC', 'LEISURE'],
  },
  DEFAULT: {
    appliancePlateImage: 'img_appliance-info-plates_generic.jpg',
    modelImages: [],
    brands: [],
  },
  VOKERA: {
    appliancePlateImage: 'img_appliance-info-plates_vokera.jpg',
    modelImages: [],
    brands: ['HEATING SERVICES', 'PROCOMBI', 'SABRE'],
  },
  GDHA: {
    appliancePlateImage: 'img_appliance-info-plates_generic.jpg',
    modelImages: [],
    brands: ['BELLING', 'LEC', 'NEW WORLD', 'STOVES'],
  },
} as const;

export const getBrandImagesForManufacturer = (
  applianceCode: string = '',
  superCategory: string = '',
  manufacturer: string = ''
): string | null => {
  manufacturer = manufacturer.toUpperCase();
  applianceCode = applianceCode.toUpperCase();
  superCategory = superCategory.toUpperCase();

  let brandWrapper = brandImages['DEFAULT'];

  if (brandImages[manufacturer]) {
    brandWrapper = brandImages[manufacturer];
  } else {
    const childBrand = Object.values(brandImages).find((brand) => {
      return brand.brands.includes(manufacturer);
    });

    if (childBrand) {
      brandWrapper = childBrand;
    }
  }

  if (brandWrapper.modelImages.length) {
    if (brandWrapper.appliancePlateImage) return brandWrapper.appliancePlateImage;

    const matchingSuperCategory = brandWrapper.modelImages.find(
      (model) => model.applianceSuperCategory === superCategory
    );

    if (matchingSuperCategory && matchingSuperCategory.mappings.length) {
      const matchedApplianceCode = matchingSuperCategory.mappings.find(
        (category) => category.applianceCode === applianceCode
      );

      if (matchedApplianceCode) {
        return matchedApplianceCode.image;
      }
    } else if (matchingSuperCategory?.defaultImage) {
      return matchingSuperCategory.defaultImage;
    }

    if (brandWrapper?.appliancePlateImage) {
      return brandWrapper.appliancePlateImage;
    }
  } else if (brandWrapper?.appliancePlateImage) {
    return brandWrapper.appliancePlateImage;
  }

  return brandImages['DEFAULT'].appliancePlateImage;
};
